export default __webpack_public_path__ + "static/media/Catraca Saida.c8ece65a.svg";